<div [style.display]="isVisible() ? 'block' : 'none'" class="table-item-wrapper">
  <div [id]="htmlId()" class="table-wrapper">
    <table class="data-table">
      <thead>
        <tr>
          <!-- First column header (row labels) -->
          <th class="label-column">{{ (properties.columns[0] && properties.columns[0].label) || '' }}</th>

          <!-- Data column headers -->
          @for (column of allDataColumns(); track column.fieldName; let columnIndex = $index) {
            <th class="data-column" [style.width.px]="column.width" (click)="selectColumn(columnIndex)">
              <div class="column-header">
                <span class="column-label">{{ column.label }}</span>
              </div>
            </th>
          }
        </tr>
      </thead>

      <tbody>
        @for (rowLabel of rowLabels(); track rowIndex; let rowIndex = $index) {
          <tr class="data-row">
            <!-- Row label -->
            <td class="label-cell range-unselected">
              {{ rowLabel }}
            </td>

            <!-- Data cells -->
            @for (column of allDataColumns(); track column.fieldName; let columnIndex = $index) {
              <td
                class="data-cell"
                [ngClass]="{
                  'column-disabled': isColumnDisabled(column.fieldName),
                  'range-unselected': !isAddressWithinSelectedRange(columnIndex, rowIndex),
                  'range-selected': isAddressWithinSelectedRange(columnIndex, rowIndex),
                  'range-selected-left': isCellOnLeftOfSelectedRange(columnIndex),
                  'range-selected-top': isCellOnTopOfSelectedRange(rowIndex),
                  'range-selected-right': isCellOnRightOfSelectedRange(columnIndex),
                  'range-selected-bottom': isCellOnBottomOfSelectedRange(rowIndex)
                }"
                [style]="getCellStyle([columnIndex, rowIndex])"
                (click)="selectCell([columnIndex, rowIndex])">
                @switch (getControlType(column.fieldName)) {
                  @case ('string') {
                    <input
                      type="text"
                      class="table-input text-input"
                      (focus)="selectCell([columnIndex, rowIndex])"
                      [id]="getCellHtmlId([columnIndex, rowIndex])"
                      [name]="getCellHtmlId([columnIndex, rowIndex])"
                      [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                      [placeholder]="column.format"
                      autocomplete="off" />
                  }
                  @case ('integer') {
                    <input
                      type="text"
                      class="table-input number-input"
                      [id]="getCellHtmlId([columnIndex, rowIndex])"
                      [name]="getCellHtmlId([columnIndex, rowIndex])"
                      [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                      [mask]="getInputMask(column.fieldName) || 'separator.0'"
                      [suffix]="getFormatSuffix(column.fieldName)"
                      [maxlength]="10 + 3"
                      [thousandSeparator]="settings().numberFormat.thousandsSeparator"
                      [allowNegativeNumbers]="true"
                      [outputTransformFn]="numberOutputTransform"
                      (focus)="selectCell([columnIndex, rowIndex])" />
                  }
                  @case ('float') {
                    <input
                      type="text"
                      class="table-input number-input"
                      [id]="getCellHtmlId([columnIndex, rowIndex])"
                      [name]="getCellHtmlId([columnIndex, rowIndex])"
                      [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                      [mask]="getInputMask(column.fieldName) || 'separator.2'"
                      [suffix]="getFormatSuffix(column.fieldName)"
                      [maxlength]="10 + 4"
                      [thousandSeparator]="settings().numberFormat.thousandsSeparator"
                      [decimalMarker]="settings().numberFormat.decimalSeparator"
                      [outputTransformFn]="numberOutputTransform"
                      (focus)="selectCell([columnIndex, rowIndex])" />
                  }
                  @case ('date') {
                    <input
                      type="date"
                      class="table-input date-input"
                      [id]="getCellHtmlId([columnIndex, rowIndex])"
                      [name]="getCellHtmlId([columnIndex, rowIndex])"
                      [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                      (focus)="selectCell([columnIndex, rowIndex])" />
                  }
                  @case ('bool') {
                    <div class="checkbox-wrapper">
                      <input
                        type="checkbox"
                        class="table-checkbox"
                        [id]="getCellHtmlId([columnIndex, rowIndex])"
                        [name]="getCellHtmlId([columnIndex, rowIndex])"
                        [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                        (focus)="selectCell([columnIndex, rowIndex])" />
                      <label [for]="getCellHtmlId([columnIndex, rowIndex])"></label>
                    </div>
                  }
                  @default {
                    <input
                      type="text"
                      class="table-input unknown-control"
                      [id]="getCellHtmlId([columnIndex, rowIndex])"
                      [name]="getCellHtmlId([columnIndex, rowIndex])"
                      [formControl]="getCellFormControl(rowIndex, column.fieldName)"
                      (focus)="selectCell([columnIndex, rowIndex])" />
                  }
                }
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
